/* 龐統（字士元） */
import { defineHero, U, P } from '../define.ts';

export default defineHero({
  id: 'pangtong', name: '龐統', sub: '字士元', faction: 'shu', role: '法師', weapon: 'staff',
  look: { head: 'hood', beard: 'goatee', eye: 'fierce', skin: '#e2b48c', robe: true, fx: '#ff7a3a', c: { cloth: '#4a5a3a', sleeve: '#4a5a3a', armor: '#c9a24e', hood: '#3a3a30' } },
  skills: [
    ['雷擊', 'thunder', '召喚落雷，對落點附近造成 {125/175/225/300} 傷害。', { x: { k: 'aoe', dmg: [125, 175, 225, 300], r: 120, fx: 'thunder' }, aim: P(480, 120), cd: 10, mp: [110, 120, 130, 140] }],
    ['風之鎖', 'trap', '小型龍捲風困住目標，{1/2/3/4} 秒內無法移動和攻擊。', { x: { k: 'nuke', cc: { root: [1, 2, 3, 4], disarm: [1, 2, 3, 4] }, fx: 'ice' }, aim: U(480), cd: 30 }],
    ['風之絆', 'passive', '附近敵人移動速度 -{7/14/21/28}%。', { pv: { aura: { r: [320, 360, 400, 440], slow: [7, 14, 21, 28] } } }],
    ['龍捲風', 'command', '召喚殘暴的龍捲風 {12/18/24} 秒：範圍內敵人緩速、持續受傷，並隨機被捲上半空。', { x: { k: 'zone', r: 300, dur: [12, 18, 24], dps: [40, 60, 80], slow: 40, rcc: { knockup: 1.2 }, p: 0.25, pal: 'ice', look: 'tornado' }, aim: P(560, 300), cd: 140, mp: [200, 300, 350] }],
  ],
});
